import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Analyzer } from 'types';

export const getAnalyzersByLocation = async (
  locationId: number
): Promise<Analyzer[]> => {
  const { data }: { data: Analyzer[] } = await axios.get(
    `/api/analyzers/forlocation/${locationId}`
  );
  return data as Analyzer[];
};

type QueryFnType = typeof getAnalyzersByLocation;

type UseAnalyzersByLocationOptions = {
  locationId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useAnalyzersByLocation = ({
  locationId,
  config,
}: UseAnalyzersByLocationOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['analyzers', 'locations', locationId],
    queryFn: () => getAnalyzersByLocation(locationId),
    ...config,
  });
};
